import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  Conversation,
  GET_GLOBAL_CONVERSATIONS_PATH,
  GetGlobalConversationsErrorDto,
  GetGlobalConversationsQueryParams,
  GetGlobalConversationsSuccessDto,
} from '@/api/rest/resources/types/conversation';

export const useGlobalConversations = (filters?: GetGlobalConversationsQueryParams) => {
  const queryParams = filters ?? undefined;

  const queryFn = () => {
    return getRequest<GetGlobalConversationsSuccessDto>(GET_GLOBAL_CONVERSATIONS_PATH, undefined, queryParams);
  };

  return useSuspenseQuery<GetGlobalConversationsSuccessDto, GetGlobalConversationsErrorDto>({
    queryKey: ['conversations', queryParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};

export const useGlobalConversation = (conversationIdArg: string) => {
  const conversations = useGlobalConversations({ conversation_id: conversationIdArg }).data;
  return conversations.find((conversation: Conversation) => conversation.id === conversationIdArg);
};
